import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {  Drawer, Radio, Space } from 'antd';
import FilterInput from "components/Form/filterInput"
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { activeStatusOptions, genderOptions, maritalStatusOptions, eosOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';
import { CloseOutlined } from "@ant-design/icons";
import DateInput from 'components/Form/dateInput';

const FilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading
} = useSelector((state) => state.common);

const [reportOption, setReportOption] = useState([]);
const [departmentOption, setDepartmentOption] = useState([]);
const [nationalityOption, setNationalityOption] = useState([]);
const [positionOption, setPositionOption] = useState([]);
const [divisionOption, setDivisionOption] = useState([]);

const [costCenterOption, setCostCenterOption] = useState([]);

const [employmentDateAfter, setEmploymentDateAfter] = useState("");
const [employmentDateBefore, setEmploymentDateBefore] = useState("");


useEffect(()=>{
    let _reports = reportTo.map(item=> {
        return{
            label: item.first_name,
            value: item.user_id
        }
    })
    let _departments = department.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _nationality = nationality.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _position = position.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })
    let _division = division.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })

    let cost_center = costCenter.map(item=> {
      return{
          label: item.code,
          value: item.id
      }
  })
  
    setReportOption(_reports)
    setDepartmentOption(_departments)
    setNationalityOption(_nationality)
    setPositionOption(_position)
    setDivisionOption(_division)
    setCostCenterOption(cost_center)
},[department, reportTo, nationality, position, division, costCenter])





   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
          if(key == "nationality"){
            return selectedValue.value
          }
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };

//   useEffect(()=>{
//     console.log(filters, "Filters")
//     let _employmentDateAfter = filters.find(item=> item.key === "employment_date_after")?.value
//     let _employmentDateBefore = filters.find(item=> item.key === "employment_date_before")?.value
//     console.log(_employmentDateAfter, _employmentDateBefore, "Start Date, End Date")
//     setEmploymentDateAfter(_employmentDateAfter)
//     setEmploymentDateBefore(_employmentDateBefore)
// },[filters])

  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        closeIcon={<i className='la la-close text-danger' />} // Custom close icon (optional)
      >
         <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>
        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("employment_date_after")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "employment_date_after")}} 
        id="search" 
        label={"Joined after"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("employment_date_before")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "employment_date_before")}} 
        id="search" 
        label={"Joined before"} 
        />
        </div>



        {/* <div className='col-12 mb-3' >
        <FilterInput   inputValue={setInputValue("search")}  handleInputChange={e=>{handleInputChange(e.target.value, "search")}} id="search" placeholder={searchPlaceholder} />
        </div> */}
       

        {/* <div className='col-12 mb-3' >
        <FilterSelect loading options={[]} value={""} placeholder={"Select destination"}/>
        </div> */}

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "gender")}} optionLabel={"label"} optionValue={'value'} options={genderOptions} value={setFilterValue("gender")} placeholder={"Gender"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "report_to")}} optionLabel={"label"} optionValue={'value'} isLoading={reportToLoading} value={setFilterValue("report_to")} options={reportOption}  placeholder={"Report to"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'}  options={departmentOption} isLoading={departmentLoading}  value={setFilterValue("department")} placeholder={"Department"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isMulti={true} isClearable={true}  onChange={e=>{handleFilterChange(e, "nationality")}} optionLabel={"label"} optionValue={'value'}  options={nationalityOption} isLoading={nationalityLoading}  value={setFilterValue("nationality")} placeholder={"Nationality"}/>
        </div>

         <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "position")}} optionLabel={"label"} optionValue={'value'}  options={positionOption} isLoading={positionLoading} value={setFilterValue("position")} placeholder={"Designation"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "division")}} optionLabel={"label"} optionValue={'value'}  options={divisionOption} isLoading={divisionLoading} value={setFilterValue("division")} placeholder={"Division"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "marital_status")}} optionLabel={"label"} optionValue={'value'} options={maritalStatusOptions}  value={setFilterValue("marital_status")} placeholder={"Marital Status"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption}  value={setFilterValue("cost_center")} placeholder={"Cost Center"} isLoading={costCenterLoading}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "status")}} optionLabel={"label"} optionValue={'value'} options={[{label: "All", value: "all"},...activeStatusOptions]}  value={setFilterValue("status")} placeholder={"Status"} />
        </div>


        <div className='col-12 mb-3' >
          <DateInput 
            selected={setFilterValue("resigned_date_after")?.value}  
            onChange={e=>{handleDateChange(e.target.value, "resigned_date_after")}} 
            id="resigned_date_after" 
            label={"Resigned after"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <DateInput 
            selected={setFilterValue("resigned_date_before")?.value}  
            onChange={e=>{handleDateChange(e.target.value, "resigned_date_before")}} 
            id="resigned_date_before" 
            label={"Resigned before"} 
          />
        </div>

        <div className='col-12 mb-3' >
          <FilterSelect 
            isClearable={true} 
            onChange={e=>{handleFilterChange(e, "eos_approved")}} 
            optionLabel={"label"} 
            optionValue={'value'} 
            options={eosOptions}  
            value={setFilterValue("eos_approved")} 
            placeholder={"End of service"} 
          />
        </div>

        <div className="col-12">
        <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>

       
       {/* <button disabled={filterLoading}  onClick={handleApplyFilter} className="btn btn-primary  w-100">
         Search
         &nbsp;
         {
            filterLoading &&
            <i class="fa fa-spinner fa-spin" ></i>

         }
       </button> */}
     </div>

      </Drawer>
    </>
  );
};
export default FilterDrawer;